export const LAYER_NEWS_DETAIL = 'newsDetailId';
export const LAYER_NEWS_CHANNEL = 'addNewsChannel';
export const LAYER_ADD_VENDOR_REVIEW = 'addReviewVendor';
